<template>
  <div :class="{ 'invoice-customer-section--edit': editMode }">
    <v-card-text class="pb-0">
      <v-row v-if="!isCustomer">
        <v-col>
          <span>Select Donor</span>
          <DonorsAutoComplete
            v-model="selectedCustomer"
            @reset="$emit('reset')"
            :initValue="setCustomer"
            :errorMessages="selectCustomerError"
          />
        </v-col>
        <v-col>
          <span>Select Campaign</span>
          <Campaign v-model="selectedCampaign" :initValue="initCampaign" />
        </v-col>
      </v-row>
      <v-row v-else>
        <v-col>
          <span>Select Parent</span>
          <ParentAutoComplete
            v-model="selectedCustomer"
            @reset="$emit('reset')"
            :initValue="setCustomer"
            :errorMessages="selectCustomerError"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-expansion-panels v-if="selectedCustomer" flat>
      <v-expansion-panel>
        <v-expansion-panel-header class="pt-0 pb-0">
          <v-row align="center" justify="space-between">
            <v-col>
              <span class="font-weight-medium text-capitalize">
                {{ selectedCustomer.name }}</span
              >
              <span class="ml-1"
                >{{ selectedCustomer.address }}
                <span v-if="selectedCustomer.city"
                  >{{ selectedCustomer.city }},
                  <span>{{ selectedCustomer.state }}</span>
                  {{ selectedCustomer.zip }}</span
                >
              </span>
            </v-col>

            <v-col>
              <div class="text-right subtitle-1 font-weight-regular">
                <span>Balance: </span>
                <span class="font-weight-bold">{{
                  selectedCustomer.balance | currency
                }}</span>
              </div>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card outlined>
            <v-card-text>
              <v-row>
                <v-col v-if="selectedCustomer">
                  <v-textarea
                    readonly
                    outlined
                    hide-details
                    dense
                    v-model="selectedCustomer.note"
                    label="Customer Note"
                  ></v-textarea>
                </v-col>
                <v-col>
                  <v-textarea
                    outlined
                    dense
                    hide-details
                    v-model="Invoice.note"
                    label="Invoice Note"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <DateSelector label="Due Date" v-model="Invoice.dueDate" />
                </v-col>
                <v-col>
                  <DateSelector
                    label="Date"
                    :initValue="initDate"
                    v-model="Invoice.date"
                  />
                </v-col>
                <v-col class="shrink">
                  <v-btn rounded dark @click="editDialog = true" color="purple">
                    <v-icon class="mr-2" small>edit</v-icon>
                    Edit
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import DateSelector from "@/components/DateSelector";
import { mapGetters, mapActions } from "vuex";
import DonorsAutoComplete from "@/modules/Donors/components/AutoComplete.vue";
import ParentAutoComplete from "@/modules/Customer/components/AutoComplete.vue";
import Campaign from "@/modules/Campaign/components/AutoComplete.vue";
// const Edit = () => import("@/modules/Customer/components/Edit");

// this.$moment().toISOString(),
export default {
  props: {
    selectCustomerError: {
      default: function () {
        return [];
      },
    },
    initValue: {
      type: Object,
      default: null,
    },
    initCamp: {
      default: null,
    },
    type: {
      default: null,
    },
    initInvoice: {
      default: null,
    },
    isCustomer: {
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editDialog: false,
      initCampaign: null,
      setCustomer: null,
      initDate: null,
      initDueDate: null,
    };
  },
  components: {
    DateSelector,
    DonorsAutoComplete,
    ParentAutoComplete,
    Campaign,
  },
  created() {
    // console.log("this.Invoice.Date", this.Invoice.date);

    if (this.Invoice.date) {
      this.SetInvoiceDate(this.$moment(this.Invoice.date).toISOString());
    } else {
      this.SetInvoiceDate(this.$moment().toISOString());
    }

    if (this.Invoice.dueDate) {
      this.SetInvoiceDate(this.$moment(this.Invoice.dueDate).toISOString());
    } else {
      this.SetInvoiceDate(this.$moment().toISOString());
    }
    // this.SetInvoiceDate(this.$moment(this.Invoice.date).toISOString());
    // this.SetInvoiceDueDate(this.$moment(this.Invoice.dueDate).toISOString());

    // if (this.$route.query && this.$route.query.CustomerId) {
    //   const id = this.$route.query.CustomerId;
    // this.initDonor = id;
    // }
  },
  watch: {
    initCamp(val) {
      console.log('test', val)
      this.initCampaign = val;
    },
    initInvoice(val) {
      this.initDate = val.date;
      this.initDueDate = val.dueDate;
    },
    initValue(val) {
      console.log("initValue", val);
      // this.initCampaign = this.initDonor.SalesRep;
      this.setCustomer = val;
    },
  },
  computed: {
    ...mapGetters("invoice", [
      "InvoiceDetails",
      "Invoice",
      "invoiceTotal",
      "getSelectedCampaign",
      "getSelectedCustomer",
      "getTrackingNumber",
      "currentUser",
    ]),
    ...mapGetters("global", ["currentUser"]),
    invoiceDueDate: {
      get: function () {
        return this.getInvoiceDueDate;
      },
      set: function (val) {
        this.SetInvoiceDueDate(val);
      },
    },
    invoiceDate: {
      get: function () {
        return this.getInvoiceDate;
      },
      set: function (val) {
        this.SetInvoiceDate(val);
      },
    },
    invoiceNote: {
      get: function () {
        return this.getInvoiceNote;
      },
      set: function (val) {
        this.SetInvoiceNote(val);
      },
    },
    trackingNumber: {
      get: function () {
        return this.getTrackingNumber;
      },
      set: function (val) {
        this.SetTrackingNumber(val);
      },
    },
    selectedCustomer: {
      get: function () {
        return this.getSelectedCustomer;
      },
      set: function (val) {
        this.SetSelectedCustomer(val);
      },
    },
    selectedCampaign: {
      get: function () {
        return this.getSelectedCampaign;
      },
      set: function (val) {
        this.SetSelectedCampaign(val);
      },
    },
  },
  methods: {
    ...mapActions("invoice", [
      "SetSelectedCustomer",
      "SetTrackingNumber",
      "SetInvoiceDueDate",
      "SetInvoiceDate",
      "SetSelectedCampaign",
    ]),
    // customerChange(val) {
    //   if (val.SalesRep) {
    //     this.initCampaign = val.SalesRep;
    //   } else {
    //     this.initCampaign = this.currentUser;
    //   }
    // },
  },
};
</script>

<style scoped>
.invoice-customer-section--edit ::v-deep .v-card__text {
  padding-top: 12px;
}

.invoice-customer-section--edit ::v-deep .v-expansion-panel-header {
  min-height: 58px;
  border-top: 1px solid #edf1ed;
}

@media (max-width: 599px) {
  .invoice-customer-section--edit ::v-deep .v-card__text {
    padding: 10px 16px 4px;
  }

  .invoice-customer-section--edit ::v-deep .v-expansion-panel-header {
    padding: 10px 16px;
  }

  .invoice-customer-section--edit ::v-deep .v-expansion-panel-header .row {
    margin: 0;
    align-items: flex-start !important;
    flex-direction: column;
  }

  .invoice-customer-section--edit ::v-deep .v-expansion-panel-header .col {
    width: 100%;
    padding: 2px 0;
  }

  .invoice-customer-section--edit ::v-deep .v-expansion-panel-header .text-right {
    margin-top: 5px;
    text-align: left !important;
    font-size: 13px !important;
  }
}
</style>
